export default "__VITE_ASSET__CXvu2JF1__"